export function getNavId(col: number, row: number) {
  return `nav-item-${col}-${row}`;
}
